export const SIDE_PANEL_TAB = {
  QuickView: 'quick-view',
  Application: 'application',
  Messages: 'messages',
} as const;

export type SidePanelTab = (typeof SIDE_PANEL_TAB)[keyof typeof SIDE_PANEL_TAB];
